import Repository from "./Repository";
import masterRepository from "./masters/masterRepository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const project = "/project/getProject";
const create = "/project/createProject";
const update = "/project/updateProject";
const updateBill = "/project/updateBill";
const getVersion = "/project/getVersion";
const updateTaskList = "/task-manager/project/updateTasklist";
const getTaskList = "/task-manager/project/gettasklist";
export default {
  createProject(payload) {
    return Repository.post(`${create}`, payload);
  },

  getProject(payload) {
    return Repository.post(`${project}`, payload);
  },

  updateProject(payload) {
    return Repository.post(`${update}`, payload);
  },
  getRoles(payload) {
    return Repository.post(`${getRoles}`, payload);
  },

  updateBill(payload) {
    return Repository.post(`${updateBill}`, payload);
  },
  getVersion(payload) {
    return masterRepository.post(`${getVersion}`, payload);
  },
  updateTaskList(payload) {
    return masterRepository.post(`${updateTaskList}`, payload);
  },
  getTaskList(payload) {
    return masterRepository.post(`${getTaskList}`, payload);
  },
};
